import Vue from 'vue';
//配置路由
import VueRouter from 'vue-router'
Vue.use(VueRouter);
//1.创建组件
import Index from '@/views/index'
import Home from '@/views/home'
import Login from '@/views/login'
import NotFound from '@/views/404'
import UpdatePassword from '@/views/update-password'
import pay from '@/views/pay'
import register from '@/views/register'
import center from '@/views/center'
import yonghu from '@/views/modules/yonghu/list'
import sheyingshi from '@/views/modules/sheyingshi/list'
import category from '@/views/modules/category/list'
import news from '@/views/modules/news/list'
import photographs from '@/views/modules/photographs/list'
import orders from '@/views/modules/orders/list'
import chatmessage from '@/views/modules/chatmessage/list'
import friend from '@/views/modules/friend/list'
import users from '@/views/modules/users/list'
import discussnews from '@/views/modules/discussnews/list'
import discussphotographs from '@/views/modules/discussphotographs/list'
import discussintel from '@/views/modules/discussintel/list'
import config from '@/views/modules/config/list'

//2.配置路由   注意：名字
export const routes = [{
	path: '/',
	name: '系统首页',
	component: Index,
	children: [{
		// 这里不设置值，是把main作为默认页面
		path: '/',
		name: '系统首页',
		component: Home,
		meta: {icon:'', title:'center', affix: true}
	}, {
		path: '/updatePassword',
		name: '修改密码',
		component: UpdatePassword,
		meta: {icon:'', title:'updatePassword'}
	}, {
		path: '/pay',
		name: '支付',
		component: pay,
		meta: {icon:'', title:'pay'}
	}, {
		path: '/center',
		name: '个人信息',
		component: center,
		meta: {icon:'', title:'center'}
	}
	,{
		path: '/yonghu',
		name: '用户信息',
		component: yonghu
	}

	,{
		path: '/sheyingshi',
		name: '摄影师信息',
		component: sheyingshi
	}
	,{
		path: '/category',
		name: '作品分类',
		component: category
	}
	,{
		path: '/news',
		name: '公告资讯',
		component: news
	}
	,{
		path: '/photographs',
		name: '作品信息',
		component: photographs
	}

	,{
		path: '/orders',
		name: '预约信息',
		component: orders
	}
	,{
		path: '/ordersstat',
		name: '预约统计',
		component: orders
	}

	,{
		path: '/chatmessage',
		name: '消息表',
		component: chatmessage
	}
	,{
		path: '/friend',
		name: '好友表',
		component: friend
	}
	,{
		path: '/users',
		name: '管理员',
		component: users
	}
	,{
		path: '/discussnews',
		name: '资讯评论',
		component: discussnews
	}
	,{
		path: '/discussphotographs',
		name: '作品评论',
		component: discussphotographs
	}
	,{
		path: '/discussintel',
		name: '摄影师评论',
		component: discussintel
	}
	,{
		path: '/config/:type',
		name: '配置管理',
		component: config
	}
	]
	},
	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {icon:'', title:'login'}
	},
	{
		path: '/register',
		name: 'register',
		component: register,
		meta: {icon:'', title:'register'}
	},
	{
		path: '*',
		component: NotFound
	}
]
//3.实例化VueRouter  注意：名字
const router = new VueRouter({
	mode: 'hash',
	/*hash模式改为history*/
	routes // （缩写）相当于 routes: routes
})
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
export default router;
